import React from "react";

interface ProfilePictureProps {
  username: string;
  className?: string;
  textStyle?: string;
  is_active?: boolean | null; // Optional prop to indicate if the user is active
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({
  username,
  className,
  textStyle,
  is_active = false,
}) => {
  const getRandomColor = (): string => {
    const colors = [
      "bg-blue-500",
      "bg-green-500",
      "bg-yellow-500",
      "bg-indigo-500",
      "bg-pink-500",
      "bg-purple-500",
      "bg-red-500",
    ];
    var randomIndex;
    if (username === null || username === undefined) {
      randomIndex = 2;
    } else {
      randomIndex = Math.floor(username.length % colors.length);
    }
    return colors[randomIndex];
  };

  const getInitials = (name: string): string | undefined => {
    if (name !== null && name !== "" && name !== undefined) {
      const parts = name.split(" ").filter((part) => /^[a-zA-Z]+$/.test(part)); // Filter to include only alphabetic parts
      // console.log(parts);
      
      if (parts.length > 1) {
        return (
          parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase()
        );
      } else if(parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
      }else{
        return name.charAt(0).toUpperCase();
      }
    }
  };
  

  const initials = getInitials(username);
  const randomBackgroundColor = getRandomColor();

  return (
    <div
      className={`
        w-[35px]
        h-[35px]
        p-2
        relative
        rounded-full
        flex items-center justify-center
        text-white
        ${randomBackgroundColor}
        ${className || ""}
      `}
    >
      <span
        className={`
          text-center text-lg font-bold w-[35px]
          ${textStyle || ""}
        `}
      >
        {initials}
      </span>

      {/* Status dot */}
     {
      is_active!==null &&  <span
      className={`
        absolute bottom-0 right-0
        block
        w-3.5 h-3.5
        rounded-full
        border-2 border-white
        ${is_active ? "bg-green-500" : "bg-gray-400"}
      `}
    />
     }
    </div>
  );
};

export default ProfilePicture;
